<template>
  <div class="accountPwdPage">
    <!-- header start -->
    <van-nav-bar 
      title="修改密码" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <van-cell-group class="martop0">
      <van-field
        v-model="oldPassword"
        type="password"
        label="输入旧密码："
      />
      <van-field
        v-model="newPassword"
        type="password"
        label="输入新密码："
      />
      <van-field
        v-model="confirmNewPassword"
        type="password"
        label="再次输入新密码："
      />
    </van-cell-group>

    <div class="btn-area">
      <van-button class="mybtn" size="large" @click="onSubmit" >提交</van-button>
    </div>

  </div>
</template>

<script>
  import { Toast } from 'vant'
	export default {
	  data() {
	    return {
        oldPassword : "",
        newPassword : "",
        confirmNewPassword : "",
        isSubmit : false,
	    };
	  },
	  components: {
    },
		methods :{
			onClickLeft() {
			  this.$router.go(-1)
      },
      onSubmit(){
        if(this.isSubmit){
          return ;
        }
        var that = this;
        var oldPassword = this.oldPassword;
        var newPassword = this.newPassword;
        var confirmNewPassword = this.confirmNewPassword;
        if(oldPassword.trim().length == 0){
          Toast("请填写旧密码");
          return;
        }
        if(newPassword.trim().length == 0){
          Toast("请填写新密码");
          return;
        }
        if(confirmNewPassword.trim().length == 0){
          Toast("请再次输入新密码");
          return;
        }
        if(newPassword != confirmNewPassword){
          Toast('两次输入的密码不一致');
          return ;
        }
        var params = {
          type:"MemberUpdateMemberPasswordVue",
          "oldPassword":oldPassword,
          "newPassword":newPassword,
          "confirmNewPassword":confirmNewPassword,
        }
        
        this.isSubmit = true;
        this.$store.dispatch(params).then(res => {
          Toast(res.Message);
          that.isSubmit = false;
          if(res.IsSuccess){
            setTimeout(function (){
              that.$router.go(-1);
            },1200)
          }
        }, err => {
          that.isSubmit = false;
        })
        
      }
		},
	};
</script>

<style>
.accountPwdPage .van-field__label{
  width: 130px;
  text-align: right;
  margin-right: 10px;
}
</style>
